import { makeStyles } from '@material-ui/core';
import byxSymbol from './byx-symbol.png';

const useStyles = makeStyles({
  img: {
    height: 28,
    width: 'auto',
    display: 'block',
    // O símbolo é indigo; na sidebar (sempre escura) vira branco, como
    // no design "Backstage byx".
    filter: 'brightness(0) invert(1)',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img className={classes.img} src={byxSymbol} alt="byx" />;
};
